import { ref, computed } from 'vue';
import apiClient from '@/api/apiClient';

// Loads the user's subcategories and exposes them grouped by category, ready for
// a grouped <select> ({ "Category name": [{ value, label }] }).
export function useSubcategoryOptions() {
    const subcategories = ref([]);

    const fetchSubcategories = () => {
        return apiClient.get('/get-subcategories.php')
            .then((response) => {
                subcategories.value = response.data;
            })
            .catch((error) => {
                console.error('Error fetching subcategories:', error);
            });
    };

    const subcategoryGroups = computed(() => {
        const groups = {};
        subcategories.value.forEach((subcategory) => {
            if (!groups[subcategory.cat]) {
                groups[subcategory.cat] = [];
            }
            groups[subcategory.cat].push({ value: subcategory.id, label: subcategory.sub });
        });
        return groups;
    });

    return { subcategoryGroups, fetchSubcategories };
}
